import { render } from "./NyuukaPlanBulkDeleteDialog.vue?vue&type=template&id=35f0b6f9"
import script from "./NyuukaPlanBulkDeleteDialog.vue?vue&type=script&lang=js"
export * from "./NyuukaPlanBulkDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__